"use client";
import { FileTypeIcon as e } from "../file-types/FileTypeIcon.js";
import { ProgressRing as t } from "../status-icons/ProgressRing.js";
import { XCloseIcon as n } from "../icons/XCloseIcon.js";
import { Popover as r } from "../popover/Popover.js";
import { StatusFailedIcon as i } from "../status-icons/StatusFailedIcon.js";
import { Dialog as a } from "../dialog/Dialog.js";
import { FileTypeHelper as o } from "../file-types/file-type-helper.js";
import { safeHref as s } from "../inline-reference/safe-href.js";
import { attachmentBodyClass as c, attachmentShellClass as l } from "./attachment-class-names.js";
import { AttachmentCard as u } from "./AttachmentCard.js";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import m from "clsx";
import { useState as h } from "react";
//#region src/components/attachment/Attachment.tsx
var g = ({ item: a, layout: s = "pill", onDownload: h, saveConfig: g, onPreview: _, onRetry: v, onRemove: y, previewConfig: b, className: x }) => {
	if (s === "card") return /* @__PURE__ */ f(u, {
		item: a,
		onPreview: _,
		onRetry: v,
		onRemove: y,
		onDownload: h,
		saveConfig: g,
		className: x,
		previewConfig: b
	});
	let S = a.upload?.status ?? "ready", C = S === "failed", w = C ? v : S === "ready" ? _ : void 0, T = /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f("span", {
		className: "pf:flex pf:shrink-0 pf:size-xl pf:items-center pf:justify-center",
		children: a.upload?.status === "uploading" ? /* @__PURE__ */ f(t, {
			value: a.upload.progress,
			label: `Uploading ${a.filename}`
		}) : C ? /* @__PURE__ */ f(i, { size: 16 }) : /* @__PURE__ */ f(e, {
			size: 16,
			kind: a.kind === "folder" ? "folder" : a.kind === "image" || a.mediaType?.startsWith("image/") ? "image" : o.fromFilename(a.filename)
		})
	}), /* @__PURE__ */ f("span", {
		className: "pf:min-w-0 pf:truncate",
		children: a.filename
	})] }), E = w || S === "ready" && b ? /* @__PURE__ */ f("button", {
		type: "button",
		className: m(c, "pf:cursor-pointer"),
		"aria-label": `${C ? "Retry" : "Preview"} ${a.filename}`,
		onClick: () => w?.(a),
		children: T
	}) : /* @__PURE__ */ f("span", {
		className: c,
		children: T
	});
	return /* @__PURE__ */ p("span", {
		"data-pf-attachment": "",
		"data-status": S,
		className: m(l, C ? "pf:border pf:border-red-300 pf:text-red-800" : "pf:border-[0.5px] pf:border-soft-pearl-300", S === "uploading" ? "pf:text-soft-pearl-800" : !C && "pf:text-soft-pearl-1000", x),
		children: [
			S === "ready" && b ? /* @__PURE__ */ f(r, {
				mode: "preview",
				title: a.filename,
				trigger: E,
				loadingConfig: { isLoading: b.isLoading ?? !1 },
				children: b.content
			}) : E,
			a.upload?.status === "failed" && /* @__PURE__ */ f("span", {
				className: "pf:sr-only",
				role: "status",
				children: a.upload.error
			}),
			y && /* @__PURE__ */ f("button", {
				type: "button",
				className: "pf:flex pf:shrink-0 pf:size-xl pf:items-center pf:justify-center pf:rounded-xs pf:border-0 pf:bg-transparent pf:p-0 pf:text-soft-pearl-800 pf:cursor-pointer pf:hover:text-soft-pearl-1000 pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700",
				"aria-label": `Remove ${a.filename}`,
				onClick: () => {
					y(a);
				},
				children: /* @__PURE__ */ f(n, { size: 16 })
			})
		]
	});
};
function _(e) {
	let [t, n] = h(!1), r = s(e.item.url), i = e.item.kind === "image" || e.item.mediaType?.startsWith("image/"), o = e.previewConfig ?? (r && i ? { content: /* @__PURE__ */ f("img", {
		src: r,
		alt: e.item.filename,
		className: "pf:block pf:max-w-full pf:max-h-[60dvh] pf:object-contain pf:mx-auto"
	}) } : void 0);
	return /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(g, {
		...e,
		previewConfig: o,
		onPreview: e.onPreview ?? (o ? () => {
			n(!0);
		} : void 0)
	}), /* @__PURE__ */ f(a, {
		open: t,
		onOpenChange: n,
		title: e.item.filename,
		size: "lg",
		children: o?.content
	})] });
}
//#endregion
export { _ as Attachment };
